<div class="mat-typography">
  <div class="dialog-header">
    Point Preview
  </div>
  <mat-tab-group dynamicHeight [(selectedIndex)]="selectIndex" preserveContent="true"
  (animationDone)="forceRedrawChart()">
    @for (tab of filterLayers() | keyvalue:sortValue; track tab) {
      <mat-tab [label]="layerLabelTransform(tab.value.layer?.layer.name)"
        >
        <div class="horizontal-separator"></div>
        <div class="content">
          @if (tab.value.layer?.layer.name == 'all' && layerData.length) {
            <div class="all-container">
              <div class="layer-header exposure-header">
                <div>
                  <span class="layer-name">Exposure Center Point</span>
                  <span> Value: </span>
                  <span class="layer-readings">{{ layersObj['exposure']?.value }}</span>
                </div>
              </div>
              <table mat-table class="team-table" [dataSource]="getLayerData() ">
                <ng-container matColumnDef="layer">
                  <mat-header-cell *matHeaderCellDef> Layer</mat-header-cell>
                  <mat-cell *matCellDef="let layer"> {{ layer.layer.display_name }}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="min">
                  <mat-header-cell *matHeaderCellDef> Min</mat-header-cell>
                  <mat-cell *matCellDef="let layer">
                    @if (layer.layer?.layer_name === 'landcover') {
                      -
                    }
                    @if (layer.layer?.layer_name !== 'landcover') {
                      {{ layer.data?.min?.toFixed(0) | round }}
                    }
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="max">
                  <mat-header-cell *matHeaderCellDef> Max</mat-header-cell>
                  <mat-cell *matCellDef="let layer">
                    @if (layer.layer?.layer_name === 'landcover') {
                      -
                    }
                    @if (layer.layer?.layer_name !== 'landcover') {
                      {{ layer.data?.max?.toFixed(0) | round }}
                    }
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="mean">
                  <mat-header-cell *matHeaderCellDef> Mean</mat-header-cell>
                  <mat-cell *matCellDef="let layer">
                    @if (layer.layer?.layer_name === 'landcover') {
                      -
                    }
                    @if (layer.layer?.layer_name !== 'landcover') {
                      {{ layer.data?.mean?.toFixed(0) | round }}
                    }
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="std">
                  <mat-header-cell *matHeaderCellDef> Std dev</mat-header-cell>
                  <mat-cell *matCellDef="let layer">
                    @if (layer.layer?.layer_name === 'landcover') {
                      -
                    }
                    @if (layer.layer?.layer_name !== 'landcover') {
                      {{ layer.data?.std?.toFixed(0) | round }}
                    }
                  </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
              </table>
            </div>
          }
          @if (tab.value.layer?.layer.name !== 'all') {
            <div class="layer-content">
              <div class="layer-header">
                <div>
                  <span class="layer-name">Center Point</span>
                  <span> Value: </span>
                  <span class="layer-readings">{{ calculateValueLabel(tab.value.value, tab.value) }}</span>
                  @if (tab.value.layer.layer.unit && tab.value.value !== null) {
                    <span> ({{ tab.value.layer.layer.unit }}) </span>
                  }
                </div>
                <div style="flex-grow: 1"></div>
                <div>Within 4km Buffer</div>
              </div>
              <div class="horizontal-separator"></div>
              <div class="layer-info">
                <div class="image_container">
                  <img [src]="tab.value.img" [alt]="tab.value.layer?.layer.name">
                  <div class="overlay"></div>
                  <div class="ruler">
                    2km
                  </div>
                </div>
                  @if (chartIndex == $index && tab?.value?.status) {
                      <div [id]="'chart-' + $index">
                      <apx-chart
                        #chartAPXExp
                        [series]="tab?.value?.histogram"
                        [colors]="tab?.value?.colors"
                        [chart]="chartOptions.chart"
                        [dataLabels]="chartOptions.dataLabels"
                        [plotOptions]="tab?.value?.plotOptions"
                        [yaxis]="tab?.value?.yaxis"
                        [fill]="tab?.value?.fill"
                        [xaxis]="tab?.value?.xaxis"
                        [noData]="chartOptions.noData"
                        [tooltip]="tab?.value?.tooltip"
                        [states]="chartOptions.states"
                      ></apx-chart>
                  </div>
                }
              </div>
              @if (tab.value.layer) {
                <div class="legend-info">
                  @if (isLinearLayer(tab.value.layer)) {
                    <div class="visual-progress"
                    [style.background]="getGradientBackground(tab.value.layer)"></div>
                  }
                  @if (!isLinearLayer(tab.value.layer)) {
                    <div
                      class="visual-progress discrete">
                      @for (color of getDiscreteColors(tab.value.layer); track color) {
                        <span
                        [style.background-color]="color"></span>
                      }
                    </div>
                  }
                  <div class="legend-container">
                    <div class="legends" [class.numeric]="isLinearLayer(tab.value.layer)">
                      @if (isLinearLayer(tab.value.layer)) {
                        @for (legend of getSpacedNumericLegends(tab.value.layer); track legend; let i = $index) {
                          <span
                            class="legend"
                            [style.left.%]="i * (100 / (getDiscreteColors(tab.value.layer).length - 1))"
                            [style.transform]="'translateX(-' + (i * (100 / (getDiscreteColors(tab.value.layer).length - 1))) + '%)'"
                          [title]="legend">{{ formatLegend(legend, tab.value.layer.layer.name) }}</span>
                        }
                      } @else {
                        @for (legend of getDiscreteColors(tab.value.layer); track legend) {
                          <span class="legend"
                          [title]="legend">{{ formatLegend(legend, tab.value.layer.layer.name) }}</span>
                        }
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </mat-tab>
    }
  </mat-tab-group>
</div>
<div class="button-row ">
  <button mat-button (click)="discard()">Discard</button>
  <div style="flex-grow: 1"></div>
  <button mat-button mat-dialog-close>Minimize</button>
  <button mat-button class="frmg-primary-button"
    (click)="save()">Save Point
  </button>
</div>
